import { render, staticRenderFns } from "./CheckBoxObject.vue?vue&type=template&id=5a1a563b&scoped=true&"
import script from "./CheckBoxObject.vue?vue&type=script&lang=ts&"
export * from "./CheckBoxObject.vue?vue&type=script&lang=ts&"
import style0 from "./CheckBoxObject.vue?vue&type=style&index=0&id=5a1a563b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1a563b",
  null
  
)

export default component.exports